import { use, useEffect, useState } from "react";
import "./login.css"
import { useAuth } from '../../AuthContext'; 
import axios from "axios";

import {useNavigate } from 'react-router-dom'


const Login =()=>{

 

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [name,setName] = useState('');
  const [mobile,setMobile] = useState();
  const [isCreatingPassword,setCreatePassword] = useState(false);
  const [confirmPassword,setConfirm] = useState('');
  const [error, setError] = useState('');
  const [isUserNameGenerated,setIsGenerated]=useState(false)

  const navigate = useNavigate();


  const setStatetoNull=()=>{
    setUsername('');
    setPassword('');
    setConfirm('')
    
  }

  const { login,setUser } = useAuth();



  const BASE_URL = process.env.REACT_APP_BASE_URL;

  

  const createPassword = ()=>{
  
    var data = {
      // 'email' :email,
      'username':username,
      'password':password
    }
    
    // axios({
    //   url:`http://localhost:8080/createPassword`,
    //   method:"POST",
    // // data:data,
     

    // }).then(()=>{
    //   setCreatePassword(false);
    //   localStorage.removeItem("user")
    //         localStorage.removeItem("jwtToken")
    //   setError("password created successFully");
      
    // }).catch((e)=>{
    //   alert(e.response.data);
    //   setError("please connect with Kalpana");

    // })

  }



  function logIn(){
  
    var data ={
      'username':username,
      'password':password
    }

  

    axios({
      url:`${BASE_URL}/login`,
      method:"POST",
      withCredentials:true,
      data: data

    }).then((res)=>{
      localStorage.setItem('jwtToken',res.data.token)

      setCreatePassword(false);
      setError("password created successFully");
      navigate("/dashboard")
      localStorage.setItem('user',JSON.stringify({
        id:res.data.id,
        centersList:res.data.centersList,
        role:res.data.role
      }))
      login()

      


      setUser((prevData)=>({
        ...prevData,
        ['id']:res.data.id,
        ['centersList']:res.data.centersList,
        ['role']:res.data.role

      }))
      
    }).catch((e)=>{
      console.log(e)

      setError("please connect with Kalpana");
      


    })

    // axios({
    //   url:`http://localhost:8080/createPassword`,
    //   method:"POST",
    // // data:data,
     

    // }).then(()=>{
    //   setCreatePassword(false);
    //   localStorage.removeItem("user")
    //         localStorage.removeItem("jwtToken")
    //   setError("password created successFully");
      
    // }).catch((e)=>{
    //   alert(e.response.data);
    //   setError("please connect with Kalpana");

    // })

  
  }

  const handlePasswordChange =(change)=>{
    setConfirm(change);
    if(password !== change){
      setError("password doesnt match")
    }else{
      setError();
    }

  }

    return (
      <div className="login-container">
        <div className="login-wrapper">
          <div className="login-left">
            <div className="logo-container">
              <img src="/raj.png" alt="Everest Abacus Logo" className="logo" />
            </div>
         

            {!isCreatingPassword ? (
              <div className="login-card">
                <form>
                  <input type="text" onChange={(e)=>setUsername(e.target.value)} placeholder="username" value={username} className="input-field" required />
                  <input type="password" onChange={(e)=>{setPassword(e.target.value)}} value={password} placeholder="Password" className="input-field" required />
                  <button type="submit" className="login-button" onClick={logIn}>Login</button>
                </form>
                {/* <div className="forgot-password">
                  <a onClick={() => { setStatetoNull(); setCreatePassword(true); }}>
                    Create password?
                  </a>
                </div> */}
             
              </div>
            ) : (
              <div className="login-card">
                <form>
                  <input type="text" value={username} placeholder="Username" className="input-field" onChange={(e)=>setUsername(e.target.value)} required />
                  <input type="password" value={password} placeholder="Password" onChange={(e)=>{setPassword(e.target.value)}} className="input-field" required />
                  <input type="password" value={confirmPassword} placeholder="Confirm Password" onChange={(e)=>handlePasswordChange(e.target.value)} className="input-field" required />
                  <lable>{error}</lable>
                  {/* <button type="submit" className="login-button" onClick={createPassword}>Create Password</button> */}
                </form>
                <div className="forgot-password">
                  <a onClick={() => { setStatetoNull(); setCreatePassword(false); }}>
                    Login?
                  </a>
                </div>
              </div>
            )}
               <p className="visit-site">
                  <a
                    href="https://everestabacus.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Visit our website
                  </a>
                </p>
          </div>

          <div className="login-right">
            <img src="/download.png" alt="Kids Learning Abacus" className="side-image" />
          </div>

        </div>
     

      </div>

   
    )
}


export default Login;